import React, { useEffect, useState } from "react";
import { FormikProvider, useFormik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as jnb from "react-bootstrap";
import Swal from "sweetalert2";
import CommonCardHeader from "../CommonUtils/CommonCardHeader";
import { ERROR_MSG } from "../CommonUtils/contextVariables";
import { FaEye, FaInfoCircle } from "react-icons/fa";
import { viewImage } from "../CommonUtils/viewImage";
import { ImagePdfBucket } from "../CommonUtils/ImagesBase64";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";


const getAcademicYearOptions = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 7 }, (_, index) => {
        const start = currentYear - index;
        // const end = start + 1;
        return `${start}`;
    });
};

export default function StatusofCollege() {
    const academicYearOptions = getAcademicYearOptions();
    const autonomousStatus = sessionStorage.getItem("autonomous");
    const isAutonomous = String(autonomousStatus).toLowerCase() === "true";
    const collegeCode = sessionStorage.getItem("user_id");

    const formik = useFormik({
        initialValues: {
            acYear: "",
            supportDoc: "",
        },
        validationSchema: Yup.object({
            acYear: Yup.string().required(ERROR_MSG),
            supportDoc: Yup.string().required(ERROR_MSG),
        }),
        onSubmit: (values) => {
            try {
                CommonAxiosPost(config.url.STU_URL + "savecollegestatus", values).then((res) => {
                    if (res?.data?.scode === "01") {
                        Swal.fire({ title: res?.data?.sdesc, text: "College autonomous details captured successfully.", icon: "success", });
                        GetCollegeDetails();
                        console.log("Status of College form values:", values);
                    }
                });
            } catch (error) {
                Swal.fire({ title: "Error", text: "Failed to save college autonomous details.", icon: "error" });
                console.error("Error saving Status of College form values:", error);
            }
        },
    });

    const selectedFileName = formik.values.supportDoc?.name || "";
    const [acadamicdetails, setAcadamicdetails] = useState([]);
    function GetCollegeDetails() {
        try {
            CommonAxiosGet(config.url.STU_URL + "getcollegestatus/" + collegeCode).then((res) => {
                if (res?.data?.scode === "01") {
                    const data = res?.data?.data?.[0];
                    setAcadamicdetails(data || []);
                    formik.setValues({
                        acYear: data?.ac_year || "",
                        supportDoc: data?.supprt_doc || "",
                    });
                } else { setAcadamicdetails([]); }
            });
        } catch (error) {
            console.error("Error fetching Status of College details:", error);
        }
    }
    useEffect(() => {
        if (isAutonomous) {
            GetCollegeDetails();
        }
    }, [isAutonomous]);

    if (!isAutonomous) {
        return (
            <jnb.Container
                fluid
                className="py-4 py-lg-5 mt-4 mt-lg-5"
                style={{ background: "linear-gradient(180deg, #e5ecfa 0%, #fcebeb 55%, #fceded 100%)" }}
            >
                <jnb.Row className="justify-content-center align-items-start">
                    <jnb.Col xs={12} lg={10} xl={8}>
                        <div className="bg-white rounded-4 shadow-sm border border-light p-4 p-md-5 text-center">
                            <CommonCardHeader title="Status of College" />
                            <div className="alert mt-3 mb-0 border-0 fw-medium" role="alert" style={{ backgroundColor: "#f0dada", color: "#8a1c1c" }}>
                                <FaInfoCircle /> This is for autonomous colleges.
                            </div>
                        </div>
                    </jnb.Col>
                </jnb.Row>
            </jnb.Container>
        );
    }

    return (
        <jnb.Container fluid className="py-4 py-lg-5 mt-4 mt-lg-5"
            style={{ background: "linear-gradient(180deg, #e5ecfa 0%, #fcebeb 55%, #fceded 100%)" }}>
            <jnb.Row className="justify-content-center align-items-start">
                <jnb.Col xs={12} lg={12} xl={9}>
                    <div className="st-form-card bg-white rounded-4 shadow-sm border border-light overflow-hidden">
                        <div
                            className="px-3 px-md-4 pt-3 pt-md-4 pb-2"
                            style={{ background: "linear-gradient(180deg, #ffffff 0%, #fdfefe 100%)" }}
                        >
                            <div className="d-flex flex-wrap align-items-center justify-content-between">
                                <CommonCardHeader title="Status of College" />
                            </div>
                        </div>

                        <FormikProvider value={formik}>
                            <Form onSubmit={formik.handleSubmit} className="p-3 p-md-4">
                                <jnb.Row className="g-4">
                                    <jnb.Col xs={12}>
                                        <div className="alert mb-0 border-0 fw-medium" role="alert" style={{ backgroundColor: "#f8fbff", color: "#084c75" }} >
                                            <FaInfoCircle /> This application is open only for colleges that are currently Autonomous.
                                        </div>
                                    </jnb.Col>

                                    <jnb.Col xs={12}>
                                        <div className="small">
                                            <strong className="text-danger">Note:</strong> Upload a valid supporting document with the required signatures.
                                        </div>
                                    </jnb.Col>

                                    <jnb.Col xs={12} md={6}>
                                        <jnb.Form.Label className="st-label fw-semibold text-dark mb-2">
                                            In which academic year did the college become Autonomous? <span className="text-danger">*</span>
                                        </jnb.Form.Label>
                                        <Field as="select" name="acYear" disabled={acadamicdetails?.ac_year ? true : false}
                                            className="form-control" style={{ minHeight: "46px" }} >
                                            <option value="">Select Academic Year</option>
                                            {academicYearOptions?.map((year) => (
                                                <option key={year} value={year}> {year} </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="acYear" component="div" className="text-danger extra-small mt-1" />
                                    </jnb.Col>

                                    <jnb.Col xs={12} md={6}>
                                        <jnb.Form.Label className="st-label fw-semibold text-dark mb-2">
                                            Supporting Document <span className="text-danger">*</span>
                                        </jnb.Form.Label>
                                        <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-2">
                                            <input type="file" name="supportDoc" className="form-control" style={{ minHeight: "46px" }}
                                                disabled={acadamicdetails?.supprt_doc ? true : false}
                                                onChange={(e) => {
                                                    const filename = "supportDocument";
                                                    const path = "/Uploads/StudentTransfer/";
                                                    ImagePdfBucket(e, formik, path, "supportDoc", filename, "pdf").then((uploadedPath) => {
                                                        formik.setFieldValue("supportDoc", uploadedPath || "");
                                                    });
                                                }}
                                            />
                                            {formik.values.supportDoc && (
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary"
                                                    onClick={() => { viewImage(formik.values.supportDoc) }}
                                                > <FaEye /> </button>
                                            )}
                                        </div>
                                        {/* <div className="small text-muted mt-2">Allowed: PDF/JPG/PNG, max 5 MB.</div> */}
                                        {selectedFileName && (
                                            <div className="small text-success mt-1 fw-medium">Selected: {selectedFileName}</div>
                                        )}
                                        <ErrorMessage name="supportDoc" component="div" className="text-danger extra-small mt-1" />
                                    </jnb.Col>
                                    <jnb.Col xs={12}>
                                        <div className="d-flex align-items-center justify-content-end pt-2 pt-md-3 border-top">
                                            <button type="submit" className="btn btn-primary px-4 py-2 fw-semibold shadow-sm"
                                                disabled={acadamicdetails?.ac_year}>
                                                Submit
                                            </button>
                                        </div>
                                    </jnb.Col>
                                </jnb.Row>
                            </Form>
                        </FormikProvider>
                    </div>
                </jnb.Col>
            </jnb.Row>
        </jnb.Container >
    );
}